export const WEGO_TEN_LIST = [
  "5CBA74C728B64856A7913115E1C25AA6",
  "CD969BCAAED649CE84E85BA591D2208C",
];